<script setup lang="ts">
import { useTenantStore } from '@afinius/hooks/store/useTenantStore';
import Clickable from '@afinius/ui-framework/Clickable/Clickable.vue';
import Image from '@afinius/ui-framework/Image/Image.vue';
import { classNames } from '@afinius/utilities/class-names';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  title?: string;
  link?: string;
  size?: 'xs' | 'sm' | 'md';
  shouldExpand?: boolean;
  isImageOnly?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  title: undefined,
  link: '/',
  size: 'md',
});

const { t } = useI18n();

const tenantStore = useTenantStore();

const type = computed(() =>
  tenantStore.tenant?.type ? t(`tenant.types.${tenantStore.tenant?.type}`) : undefined,
);

const prefix = computed(() =>
  props.title ? [type.value, tenantStore.tenant?.name].filter(Boolean).join(' ') : type.value,
);

const title = computed(() => props.title || tenantStore.tenant?.name);
</script>

<template>
  <Clickable :href="link" class="title" :class="classNames({ size, shouldExpand })">
    <div class="title__logo-wrap">
      <Image
        v-if="tenantStore.tenant"
        :url="tenantStore.tenant.logo_path"
        class="title__logo"
        :alt="`Logo ${prefix}`"
      />
    </div>

    <div v-if="!isImageOnly" class="title__text">
      <span class="title__prefix">{{ prefix }}</span>
      <span class="title__name">{{ title }}</span>
    </div>
  </Clickable>
</template>

<style lang="scss" scoped>
@use './Title.scss';
</style>
